import React from "react";
import { Routes, Route } from "react-router-dom";

import BasicLayout from "_common/component/Layout/BasicLayout";
import NoFooterLayout from "_common/component/Layout/NoFooterLayout";
import UnAuthLayout from "_common/component/Layout/UnAuthLayout";
import PageNotfound from "_common/component/PageNotfound";

// auth
import LoginPage from "pages/Auth/Login";
import RegisterPage from "pages/Auth/Register";

import { MiddlewareRouter } from "routers/MiddlewareRouter";
import CheckAuth from "routers/CheckAuth";
import MemberPage from "pages/Member";
import ListHistoryBalance from "pages/Wallet/ListHistoryBalance";
import Deposit from "pages/Wallet/Deposit/Deposit";

import HomeUnAuth from "pages/HomeUnAuth";
import WalletPage from "pages/Wallet";
import FundPage from "pages/Fund";
import ReportPage from "pages/Report";
import TradePage from "pages/Trade";
import MarketListPage from "pages/Market";
import Withdraw from "pages/Wallet/Withdraw/Withdraw";
import Recharge from "pages/Wallet/Deposit/Recharge";
import UpdateUser from "pages/Member/UpdateUser";
import Security from "pages/Member/Security";
import ChangePasswordPage from "pages/Member/ChangePassword";
import Complain from "pages/Wallet/Complain";
import HistoryTradePage from "pages/Trade/HistoryTradePage";
import About from "pages/Member/About";
import Exchange from "pages/Wallet/Exchange";
import Introduction from "pages/Member/Introduction";
import FeaturePage from "pages/Feature";
import SpotTradePage from "pages/SpotTrade";
import BankPage from "pages/Wallet/Bank";
import CheckAuthHome from "routers/CheckAuthHome";
import UserInfoPage from "pages/Member/UserInfo";
import WalletPassword from "pages/Member/WalletPassword";
import IntroductionDetail from "pages/Member/IntroductionDetail";
import Language from "pages/Member/Language";
import FundList from "pages/Fund/FundList";
import FundDetail from "pages/Fund/FundDetail";
import FundHistory from "pages/Fund/FundHistory";
import HistoryFeaturePage from "pages/Feature/HistoryFeaturePage";
import SetTime from "pages/Member/SetTime";
import WalletAddress from "pages/Wallet/WalletAddress";
import WalletList from "pages/Wallet/WalletAddress/WalletList";

import MSB from "pages/Member/MSB";
import ContractPage from "pages/Contract";
import IEOPage from "pages/IEO";
import StakingPage from "pages/Staking";

import ProfitListPage from "pages/Orepool/ProfitList";
import OrderPage from "pages/Trade/Order";
import OrderHistoryPage from "pages/Trade/OrderHistory";
import ContractTyPage from "pages/Contract/Desktop/ContractTy";
import ContractJcPage from "pages/Contract/Desktop/ContractJc";
import ContractPcPage from "pages/Contract/Desktop/ContractPc";
import NormalMinPage from "pages/Orepool/NormalMin";
import OverDueMinPage from "pages/Orepool/OverDueMin";
import NormalIssuePage from "pages/Issue/NormalIssue";
import OverDueIssuePage from "pages/Issue/OverDueIssue";
import IssuePage from "pages/Issue";
import OrepoolPage from "pages/Orepool";
import VerifyKYCPage from "pages/Member/VerifyKYC";
import SharingPage from "pages/Member/Sharing";
import NoticePage from "pages/Member/Notice";
import AddBankPage from "pages/Wallet/Bank/AddBankPage";
import NoticeDetail from "pages/Member/Notice/MobileNotice/NoticeDetail";

export function Routers() {
  return (
    <Routes>
      <Route
        path="/cskh"
        element={
          <CheckAuthHome>
            <UnAuthLayout />
          </CheckAuthHome>
        }
      >
        <Route index element={<Complain />} />
      </Route>

      <Route path="/" element={<BasicLayout />}>
        <Route index element={<HomeUnAuth />} />
        <Route path="home" element={<HomeUnAuth />} />
        <Route path="market" element={<MarketListPage />} />
        <Route path="contract">
          <Route index element={<ContractPage />} />
          <Route path="contract-ty" element={<ContractTyPage />} />
          <Route path="contractjc" element={<ContractJcPage />} />
          <Route path="contractpc" element={<ContractPcPage />} />
        </Route>
        <Route path="orepool">
          <Route index element={<OrepoolPage />} />
          <Route path="profit-list" element={<ProfitListPage />} />
          <Route path="normalmin" element={<NormalMinPage />} />
          <Route path="overduemin" element={<OverDueMinPage />} />
        </Route>
        <Route path="trade">
          <Route index element={<TradePage />} />
          <Route path="order" element={<OrderPage />} />
          <Route path="order-history" element={<OrderHistoryPage />} />
        </Route>
        <Route path="issue">
          <Route index element={<IssuePage />} />
          <Route path="normalissue" element={<NormalIssuePage />} />
          <Route path="overdueissue" element={<OverDueIssuePage />} />
        </Route>
      </Route>

      <Route
        path="/board"
        element={
          <MiddlewareRouter>
            <BasicLayout />
          </MiddlewareRouter>
        }
      >
        <Route index element={<TradePage />} />
        <Route path="home" element={<TradePage />} />
        <Route path="wallet" element={<WalletPage />} />
        <Route path="deposit" element={<Deposit />} />
        <Route path="withdraw" element={<Withdraw />} />
        <Route path="fund">
          <Route index element={<FundPage />} />
          <Route path="list" element={<FundList />} />
          <Route path="history" element={<FundHistory />} />
          <Route path="detail/:id" element={<FundDetail />} />
        </Route>
        <Route path="report" element={<ReportPage />} />
        <Route path="history" element={<ListHistoryBalance />} />
        <Route path="exchange" element={<Exchange />} />
        <Route path="spot" element={<SpotTradePage />} />
        <Route path="feature">
          <Route index element={<FeaturePage />} />
          <Route path="history" element={<HistoryFeaturePage />} />
        </Route>
      </Route>

      <Route
        path="/member"
        element={
          <MiddlewareRouter>
            <BasicLayout />
          </MiddlewareRouter>
        }
      >
        <Route index element={<MemberPage />} />
        <Route path="info" element={<UserInfoPage />} />
        <Route path="kyc" element={<VerifyKYCPage />} />
        <Route path="update-profile" element={<UpdateUser />} />
        <Route path="sharing" element={<SharingPage />} />
        <Route path="bank" element={<BankPage />} />
        <Route path="bank/submit" element={<AddBankPage />} />
        <Route path="about" element={<About />} />
        <Route path="wallet" element={<WalletList />} />
        <Route path="add-wallet" element={<WalletAddress />} />
        <Route path="language" element={<Language />} />
        <Route path="line" element={<SetTime />} />
        <Route path="introduction" element={<Introduction />} />
        <Route
          path="introduction/detail/:id"
          element={<IntroductionDetail />}
        />
        <Route path="security" element={<Security />} />
        <Route path="change-password" element={<ChangePasswordPage />} />
        <Route path="wallet-password" element={<WalletPassword />} />
        <Route path="recharge" element={<Recharge />} />

        <Route path="notice" element={<NoticePage />} />
        <Route path="notice/:id" element={<NoticeDetail />} />
        <Route path="msb" element={<MSB />} />
      </Route>

      <Route
        element={
          <MiddlewareRouter>
            <NoFooterLayout />
          </MiddlewareRouter>
        }
      >
        <Route path="trade" element={<TradePage />} />
        <Route path="trade/history" element={<HistoryTradePage />} />
        <Route path="ieo" element={<IEOPage />} />
        <Route path="staking" element={<StakingPage />} />
      </Route>

      <Route
        path="auth"
        element={
          <CheckAuth>
            <UnAuthLayout />
          </CheckAuth>
        }
      >
        <Route path="login" element={<LoginPage />} />
        <Route path="register" element={<RegisterPage />} />
      </Route>
      <Route path="*" element={<PageNotfound />} />
    </Routes>
  );
}
